module.exports = __webpack_public_path__ + "img/device-replace-v3-check-device-list.79d8edb6.png";